import { downloadData } from "aws-amplify/storage";
import { client } from "queryClient";
import { PriceCalc, PriceCalcBasis, PriceCalcWithBasis } from "types";

export const getPriceCalc = async (id: string): Promise<PriceCalc | null> => {
  const { data } = await client.models.PriceCalc.get({
    id,
  });

  return data;
};

/**
 * Berechnungsgrundlagen (articles, stock) aus S3. Sie werden nur im
 * Rechenweg-Dialog gebraucht und deshalb erst dort geladen. Liefert null, wenn
 * die Datei fehlt oder nicht lesbar ist; der Dialog zeigt das an, statt zu
 * scheitern.
 */
export const getPriceCalcBasis = async (
  s3Key: string,
): Promise<PriceCalcBasis | null> => {
  try {
    const { body } = await downloadData({ path: s3Key }).result;
    const text = await body.text();

    return JSON.parse(text) as PriceCalcBasis;
  } catch (error) {
    console.error(
      "Berechnungsgrundlagen konnten nicht geladen werden: ",
      s3Key,
      error,
    );

    return null;
  }
};

/** Zeile samt Grundlagen aus S3. Ohne s3Key oder ohne Datei gelten sie als fehlend. */
export const getPriceCalcWithBasis = async (
  id: string,
): Promise<PriceCalcWithBasis | null> => {
  const priceCalc = await getPriceCalc(id);

  if (!priceCalc) {
    return null;
  }

  const basis = priceCalc.s3Key
    ? await getPriceCalcBasis(priceCalc.s3Key)
    : null;

  return {
    priceCalc,
    articles: basis?.articles ?? [],
    basisMissing: !basis,
  };
};
